import { Ability } from '@casl/ability';
import { createContext } from 'react';

const AbilityContext = createContext(new Ability([]));

export default AbilityContext;
